<template>
<div>
    <div class="md-layout rows-relatorio">
        <div v-if="permissoes.repasseAnaliticoRead || permissoes.repasseSinteticoRead" class="md-layout-item md-size-100 md-xsmall-size-100">
            <strong class="text-relatorio text-site">FINANCEIRO</strong>
        </div>

        <div v-if="permissoes.repasseAnaliticoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-site" :to="{name:'repasseAnaliticoRead'}">
                <i class="fas fa-hand-holding-usd icon-relatorio text-info"></i>
                <strong class="text-relatorio">REPASSE ANALÍTICO</strong>
            </router-link>
        </div>

        <div v-if="permissoes.repasseSinteticoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-site" :to="{name:'repasseSinteticoRead'}">
                <i class="fas fa-hand-holding-usd icon-relatorio text-info"></i>
                <strong class="text-relatorio">REPASSE SINTÉTICO</strong>
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao
        }
    }
};
</script>
